var _circle, _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDanger = function SvgDanger(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    viewBox: "0 0 29 29",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.15,
    cy: 14.976,
    r: 14,
    fill: "#fcedee"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF2935",
    d: "m15.767 14.726 2.734-2.734a.812.812 0 0 0 0-1.203l-.601-.602a.812.812 0 0 0-1.203 0l-2.735 2.734-2.761-2.734a.812.812 0 0 0-1.204 0l-.601.602a.812.812 0 0 0 0 1.203l2.734 2.734-2.734 2.762a.812.812 0 0 0 0 1.203l.601.602a.812.812 0 0 0 1.204 0l2.761-2.735 2.735 2.735a.812.812 0 0 0 1.203 0l.601-.602a.812.812 0 0 0 0-1.203l-2.734-2.762Z"
  })));
};
export default SvgDanger;